import { useEffect } from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import MissionSection from './components/MissionSection';
import ServicesSection from './components/ServicesSection';
import FeaturesSection from './components/FeaturesSection';
import TestimonialsSection from './components/TestimonialsSection';
import CasesSection from './components/CasesSection';
import ConsultationSection from './components/ConsultationSection';
import CompanySection from './components/CompanySection';
import ContactSection from './components/ContactSection';
import PrivacySection from './components/PrivacySection';
import Footer from './components/Footer';

const HomePage = () => {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

    const schemas = [
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'atco（アットコ）',
        url: siteUrl,
        logo: `${siteUrl}/favicon.ico`,
        description:
          'atco（アットコ）は東京・新宿を拠点とするビジネスマッチング支援サービスです。企業間の最適なパートナーシップを実現し、新規事業開発・販路拡大・業務提携をトータルサポートします。',
        address: {
          '@type': 'PostalAddress',
          addressLocality: '新宿区',
          addressRegion: '東京都',
          addressCountry: 'JP',
        },
        contactPoint: {
          '@type': 'ContactPoint',
          contactType: 'customer service',
          availableLanguage: 'Japanese',
        },
        sameAs: ['https://bt-atco.co.jp/'],
      },
      {
        '@context': 'https://schema.org',
        '@type': 'LocalBusiness',
        name: 'atco（アットコ）',
        url: siteUrl,
        image: `${siteUrl}/og-image.jpg`,
        description:
          'ビジネスマッチング支援サービス。東京・新宿を拠点に、企業間の業務提携・販路拡大・新規事業開発をサポート。',
        address: {
          '@type': 'PostalAddress',
          addressLocality: '新宿区',
          addressRegion: '東京都',
          addressCountry: 'JP',
        },
        geo: {
          '@type': 'GeoCoordinates',
          latitude: 35.6895,
          longitude: 139.6917,
        },
        openingHoursSpecification: [
          {
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
            opens: '09:00',
            closes: '18:00',
          },
        ],
        priceRange: '¥¥',
      },
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: 'atco（アットコ）',
        url: siteUrl,
        description:
          'atco（アットコ）公式サイト。ビジネスマッチング支援サービスで東京・新宿の企業の業務提携・販路拡大を実現。',
        inLanguage: 'ja',
        potentialAction: {
          '@type': 'SearchAction',
          target: `${siteUrl}/?q={search_term_string}`,
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: 'atcoのビジネスマッチング支援サービスとはどのようなものですか？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'atcoは企業間の最適なパートナーシップを実現するビジネスマッチング支援サービスです。新規事業開発・販路拡大・業務提携など、企業の成長に必要なビジネスマッチングをトータルサポートします。',
            },
          },
          {
            '@type': 'Question',
            name: '無料相談はどのように申し込めますか？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'ウェブサイトのお問い合わせフォームからご連絡いただくか、お電話にてお申し込みください。初回相談は無料で承っております。',
            },
          },
          {
            '@type': 'Question',
            name: 'どのような業種・規模の企業に対応していますか？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'スタートアップから大企業まで、幅広い業種・規模の企業様に対応しております。IT・製造・サービス業など多様な業界でのマッチング実績があります。',
            },
          },
        ],
      },
    ];

    const existingScripts = document.querySelectorAll('script[data-schema="atco"]');
    existingScripts.forEach((s) => s.remove());

    schemas.forEach((schema, index) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-schema', 'atco');
      script.setAttribute('data-schema-index', String(index));
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    });

    return () => {
      const scripts = document.querySelectorAll('script[data-schema="atco"]');
      scripts.forEach((s) => s.remove());
    };
  }, []);

  return (
    <div className="min-h-screen font-sans">
      <Navbar />
      <HeroSection />
      <MissionSection />
      <ServicesSection />
      <FeaturesSection />
      <TestimonialsSection />
      <CasesSection />
      <ConsultationSection />
      <CompanySection />
      <ContactSection />
      <PrivacySection />
      <Footer />
    </div>
  );
};

export default HomePage;
